import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { WHeader } from '@/widgets/WHeader'
import { useUser } from '@/shared/composables'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isAuth } = useUser()

const isAuthPage = computed(() => isAuth.value)

const route = useRoute()

const isPreviewMode = computed(() => route.query['view-mode'] === '1')

let isBluePage = computed(() =>
  [
    'AuthPage',
    'ClinicChoicePage',
    'NewPasswordPage',
    'PasswordRecoveryPage',
  ].includes(String(route.name))
)

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'blue-pages': _unref(isBluePage) }, "layout"])
  }, [
    (_unref(isAuthPage))
      ? (_openBlock(), _createBlock(_unref(WHeader), {
          key: 0,
          class: "layout__header"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'non-blue-pages': !_unref(isBluePage) }, "layout__content"])
    }, [
      _createVNode(_component_router_view, { class: "layout__content-page" })
    ], 2)
  ], 2))
}
}

})